import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Zap } from 'lucide-react';

const NewTaskDialog = ({ 
  open, 
  onOpenChange, 
  selectedAgent,
  newTaskForm,
  setNewTaskForm,
  onAddTask
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Zap className="h-5 w-5" />
            Add Manual Task
          </DialogTitle>
          <DialogDescription>
            Assign a task to {selectedAgent?.name}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Label>Task Title *</Label>
            <Input
              value={newTaskForm.title}
              onChange={(e) => setNewTaskForm({ ...newTaskForm, title: e.target.value })}
              placeholder="e.g., Follow up with lead"
              className="mt-1"
            />
          </div>
          <div>
            <Label>Description / Instructions</Label>
            <Textarea
              value={newTaskForm.description}
              onChange={(e) => setNewTaskForm({ ...newTaskForm, description: e.target.value })}
              placeholder="Provide detailed instructions for this task..."
              className="mt-1"
            />
          </div>
          <div>
            <Label>Priority</Label>
            <Select 
              value={newTaskForm.priority} 
              onValueChange={(val) => setNewTaskForm({ ...newTaskForm, priority: val })}
            >
              <SelectTrigger className="mt-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="urgent">Urgent</SelectItem>
                <SelectItem value="high">High</SelectItem>
                <SelectItem value="normal">Normal</SelectItem>
                <SelectItem value="low">Low</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Link to Record (Optional)</Label>
            <Input
              value={newTaskForm.linkToRecord}
              onChange={(e) => setNewTaskForm({ ...newTaskForm, linkToRecord: e.target.value })}
              placeholder="URL or record ID"
              className="mt-1"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onAddTask}>Add Task</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default NewTaskDialog;